<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6ZM18 7H6V9H18V7ZM18 11H6V13H18V11ZM6 15H13V17H6V15Z"
    fill="#1E72EF"
  />
</template>
